<template>
  <el-dropdown size="small" class="d2-mr">
    <span class="btn-text user-entry">{{info.name ? `你好 ${info.name}` : '未登录'}}</span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item @click.native="openPasswordDialog">
        <d2-icon name="lock" class="d2-mr-5"/>
        修改密码
      </el-dropdown-item>
      <el-dropdown-item @click.native="openWorkWechatDialog">
        <d2-icon name="link" class="d2-mr-5"/>
        绑定企业微信
      </el-dropdown-item>
      <el-dropdown-item @click.native="logOff">
        <d2-icon name="power-off" class="d2-mr-5"/>
        退出登录
      </el-dropdown-item>
      <div class="header-user-version">版本号：v{{$version}}</div>
    </el-dropdown-menu>

    <el-dialog title="修改密码" :visible.sync="passwordDialogVisible" width="420px"
               :close-on-click-modal="false" append-to-body>
      <el-form ref="passwordForm" :model="passwordForm" :rules="passwordRules" label-width="90px">
        <el-form-item label="当前密码" prop="currentPassword">
          <el-input v-model="passwordForm.currentPassword" type="password" show-password autocomplete="current-password"/>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="passwordForm.newPassword" type="password" show-password autocomplete="new-password"/>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="passwordForm.confirmPassword" type="password" show-password autocomplete="new-password"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="passwordDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="passwordSubmitting" @click="submitPasswordChange">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="绑定企业微信" :visible.sync="workWechatDialogVisible" width="460px"
               :close-on-click-modal="false" append-to-body @closed="stopWorkWechatCountdown">
      <el-alert
        title="复制绑定码后，在企业微信应用中发送给机器人；绑定成功后即可接收审批和付款通知。"
        type="info" :closable="false" show-icon/>
      <div class="work-wechat-binding-status" v-if="workWechatBound">
        <el-tag type="success">已绑定</el-tag>
        <span v-if="workWechatBoundUserId">企业微信账号：{{workWechatBoundUserId}}</span>
      </div>
      <div v-else class="work-wechat-binding-code">
        <div class="work-wechat-code-label">绑定码</div>
        <el-input v-model="workWechatBindingCode" readonly placeholder="正在生成绑定码...">
          <el-button slot="append" :disabled="!workWechatBindingCode" @click="copyWorkWechatCode">复制</el-button>
        </el-input>
        <div class="work-wechat-code-tip" v-if="workWechatExpiresInSeconds > 0">
          绑定码有效期 {{workWechatExpiresInSeconds}} 秒，仅可使用一次
        </div>
      </div>
      <span slot="footer">
        <el-button @click="fetchWorkWechatBinding">刷新绑定状态</el-button>
        <el-button type="primary" :loading="workWechatLoading" @click="createWorkWechatCode">重新生成绑定码</el-button>
      </span>
    </el-dialog>
  </el-dropdown>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import request from '@/util/request'
export default {
  data () {
    return {
      passwordDialogVisible: false,
      passwordSubmitting: false,
      passwordForm: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      workWechatDialogVisible: false,
      workWechatLoading: false,
      workWechatBindingCode: '',
      workWechatExpiresInSeconds: 0,
      workWechatBound: false,
      workWechatBoundUserId: '',
      workWechatCountdownTimer: null,
      passwordRules: {
        currentPassword: [{ required: true, message: '请输入当前密码', trigger: 'blur' }],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 64, message: '密码长度为 6-64 位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (value !== this.passwordForm.newPassword) {
              callback(new Error('两次输入的密码不一致'))
            } else {
              callback()
            }
          }, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState('d2admin/user', [
      'info'
    ])
  },
  methods: {
    ...mapActions('d2admin/account', [
      'logout'
    ]),
    /**
     * @description 登出
     */
    logOff () {
      this.logout({
        confirm: true
      })
    },
    openPasswordDialog () {
      this.passwordForm = {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
      this.passwordDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.passwordForm) {
          this.$refs.passwordForm.clearValidate()
        }
      })
    },
    async openWorkWechatDialog () {
      this.workWechatDialogVisible = true
      this.workWechatBindingCode = ''
      this.workWechatExpiresInSeconds = 0
      await this.fetchWorkWechatBinding()
      if (!this.workWechatBound) {
        await this.createWorkWechatCode()
      }
    },
    async fetchWorkWechatBinding () {
      try {
        const res = await request.get('/gapi/work-wechat/binding-status')
        if (!res || res.status === false) {
          throw new Error((res && res.message) || '获取企业微信绑定状态失败')
        }
        this.workWechatBound = !!res.bound
        this.workWechatBoundUserId = res.workWechatUserId || ''
      } catch (error) {
        this.$message.error(error.message || '获取企业微信绑定状态失败')
      }
    },
    async createWorkWechatCode () {
      this.workWechatLoading = true
      try {
        const res = await request.get('/gapi/work-wechat/binding-code')
        if (!res || res.status === false || !res.code) {
          throw new Error((res && res.message) || '生成绑定码失败')
        }
        this.workWechatBindingCode = res.code
        this.workWechatExpiresInSeconds = Number(res.expiresInSeconds || 0)
        this.startWorkWechatCountdown()
      } catch (error) {
        this.$message.error(error.message || '生成绑定码失败')
      } finally {
        this.workWechatLoading = false
      }
    },
    startWorkWechatCountdown () {
      this.stopWorkWechatCountdown()
      this.workWechatCountdownTimer = setInterval(() => {
        if (this.workWechatExpiresInSeconds <= 1) {
          this.workWechatExpiresInSeconds = 0
          this.stopWorkWechatCountdown()
        } else {
          this.workWechatExpiresInSeconds -= 1
        }
      }, 1000)
    },
    stopWorkWechatCountdown () {
      if (this.workWechatCountdownTimer) {
        clearInterval(this.workWechatCountdownTimer)
        this.workWechatCountdownTimer = null
      }
    },
    async copyWorkWechatCode () {
      if (!this.workWechatBindingCode) return
      let copied = false
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(this.workWechatBindingCode)
          copied = true
        }
      } catch (error) {
        copied = false
      }
      if (!copied) {
        const input = document.createElement('textarea')
        input.value = this.workWechatBindingCode
        input.style.position = 'fixed'
        input.style.opacity = '0'
        document.body.appendChild(input)
        input.select()
        copied = document.execCommand('copy')
        document.body.removeChild(input)
      }
      if (copied) {
        this.$message.success('绑定码已复制')
      } else {
        this.$message.warning('复制失败，请手动复制绑定码')
      }
    },
    submitPasswordChange () {
      this.$refs.passwordForm.validate(async valid => {
        if (!valid || this.passwordSubmitting) return
        this.passwordSubmitting = true
        try {
          const res = await request.post('/api/members/password', this.passwordForm)
          if (!res || !res.status) {
            this.$message.error((res && res.message) || '修改密码失败')
            return
          }
          this.$message.success('密码修改成功，请重新登录')
          this.passwordDialogVisible = false
          setTimeout(() => this.logout({ confirm: false }), 500)
        } finally {
          this.passwordSubmitting = false
        }
      })
    }
  }
}
</script>

<style scoped>
.header-user-version {
  padding: 8px 16px 6px;
  color: #9aa5b1;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  border-top: 1px solid #ebeef5;
  cursor: default;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-user/index.vue"
}
</vue-filename-injector>
